import InteractiveCatalogPageItem from '../InteractiveCatalogPageItem';

export default class PanoramaImageItem extends InteractiveCatalogPageItem {

    constructor() {
        super();
        this.path = '';
        this.contentWidth = 0.0;
        this.contentHeight = 0.0;
    }

}
